module.exports = __webpack_public_path__ + "img/bgtop.f3eee98e.png";